import { __assign, __read } from "tslib";
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { randomizeVector } from './utils';
var createBubbleMotion = function (_a) {
    var x = _a.x, y = _a.y, middlePoint = _a.middlePoint, index = _a.index;
    var _b = __read(randomizeVector(), 2), motionX = _b[0], motionY = _b[1];
    var _c = __read(middlePoint, 2), midX = _c[0], midY = _c[1];
    return {
        initial: { opacity: 0, x: midX + motionX, y: midY + motionY },
        animate: { opacity: 0.57, x: x, y: y },
        exit: {},
        whileHover: { opacity: 1 },
        transition: { delay: 0.01 * index, ease: 'easeOut', duration: 0.25 },
    };
};
var Bubbles = function (_a) {
    var bubbles = _a.bubbles, middlePoint = _a.middlePoint, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    return (React.createElement(AnimatePresence, null, bubbles.map(function (_a, idx) {
        var key = _a.key, x = _a.x, y = _a.y, radius = _a.radius, color = _a.color, selector = _a.selector;
        return (React.createElement(motion.circle, __assign({ key: key, r: radius, fill: color, onMouseMove: function (e) {
                return onMouseEnter(e, [
                    {
                        color: color,
                        selector: selector,
                    },
                ]);
            }, onMouseLeave: function (e) {
                onMouseLeave(e);
            } }, createBubbleMotion({ x: x, y: y, middlePoint: middlePoint, index: idx }))));
    })));
};
export default Bubbles;
